const fonts = {
  baseSize: 0.625, // The base font size we want, 10, divided by the body font size we want, 16.
  bodySize: 1.6, // In REMs.
  recklessNeue: {
    regular: `
      font-family: "Reckless Neue", Georgia, Times New Roman, serif;
      font-weight: normal;
    `,
    bold: `
      font-family: "Reckless Neue", Georgia, Times New Roman, serif;
      font-weight: bold;
    `,
  },
  sohne: {
    light: `
      font-family: var(--font-family-sans-serif);
      font-weight: normal;
    `,
    regular: `
      font-family: var(--font-family-sans-serif);
      font-weight: normal;
    `,
    semibold: `
      font-family: var(--font-family-sans-serif);
      font-weight: 500;
    `,
    bold: `
      font-family: var(--font-family-sans-serif);
      font-weight: bold;
    `,
  },
  sohneMono: {
    regular: `
      font-family: var(--font-family-sans-serif);
      font-weight: normal;
    `,
    bold: `
      font-family: var(--font-family-sans-serif);
      font-weight: bold;
    `,
  },
  sohneSchmal: {
    regular: `
      font-family: "Soehne Schmal", Tahoma, Verdana, sans-serif;
      font-weight: normal;
    `,
    bold: `
      font-family: "Sohne Schmal", Tahoma, Verdana, sans-serif;
      font-weight: bold;
    `,
  },
};

export default fonts;
